export default __webpack_public_path__ + "static/media/nutrionist@3x.361b1234.png";